import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const transform = 'matrix(1,0,0,1,1,1)';

const d1 = 'M6.5,0.5L6.5,12.5';
const d2 = 'M0.5,6.5L12.5,6.5';

const Add: React.FC<IconProps> = ({
  viewBox = '0 0 15 15',
  className = '',
  fill = colors.blueGrey,
  strokeLineCap = 'square',
  strokeWidth = '2px',
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      stroke={fill}
      strokeLineCap={strokeLineCap}
      strokeWidth={strokeWidth}
      cssHelper={Styling.fullWidthStyle}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G transform={transform}>
        <Elements.Path d={d1} />
        <Elements.Path d={d2} />
      </Elements.G>
    </Elements.Svg>
  );
};

export default Add;
